export default {
  print: {
    print: 'Imprimare',
    segment: 'Segmentul',
    preparingPrinting: 'Pregătirea imprimării',
    readyToPrint: 'Gata de imprimare',
  }
}
